"use client";

import { AskSabine } from "@/components/nav/CoachLauncher";

/**
 * The cream strip above a signed-out page that registered a coach (the
 * shared playbook), on screens wide enough for the chat to open beside the
 * page. It holds the Ask button while the chat is closed, and keeps its
 * height while it is open, so the page never moves. Signed in, the navy top
 * bar (NavTopBar) holds the same button.
 *
 * @param {object} props
 * @param {string} [props.placeholder]  The page's question for Sabine
 * @param {boolean} [props.open]        Whether the coach is open
 * @param {() => void} props.onOpen     Opens the coach
 */
export default function CoachStrip({ placeholder, open, onOpen }) {
  return (
    <div className="hidden h-12 shrink-0 items-center justify-end px-4 md:flex print:hidden">
      {!open && <AskSabine placeholder={placeholder} onOpen={onOpen} />}
    </div>
  );
}
